import React, { useEffect, useState } from 'react'
import { Box, Button, IconButton, TextField } from '@mui/material'
import styles from '../modal.module.css'
import ClearIcon from '@mui/icons-material/Clear';
import * as api from '../../../pages/services/api'
import Loader from 'components/Loader';
import { styled } from '@mui/material/styles';

const NoArrowTextField = styled(TextField)({
    '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
    },
    '& input[type=number]': {
        MozAppearance: 'textfield',
    },
});

function ModalUpdateData({ onClose, data, onSubmit, year }) {

    const [detail, setDetail] = useState(data)
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([
        {
            field: '',
            value: ''
        }
    ])

    useEffect(() => {
        const currentValues = {};
        const beginValues = {};
        for (const key in data) {
            if (key.endsWith('_begin')) {
                const fieldName = key.replace('_begin', ''); // แปลง bmi_begin → bmi
                beginValues[fieldName] = data[key];
            }

            if (key.endsWith('_current')) {
                const fieldName = key.replace('_current', '');
                currentValues[fieldName] = data[key];
            }
        }
        console.log('currentValues', currentValues)
        console.log('beginValues', beginValues)
        // อัปเดต follow_up_details
        data.follow_up_details = data.follow_up_details.map(item => {
            // if (beginValues[item.field] !== undefined) {
            //     return { ...item, value: beginValues[item.field] };
            // }
            // return item;

            if (currentValues[item.field] !== '') {
                return { ...item, value: currentValues[item.field] };
            } else {
                return { ...item, value: beginValues[item.field] };
            }
        });
        // console.log(data.follow_up_details);
        setList(data['follow_up_details'])
    }, [])

    const handleChange = (e, idx, name) => {
        let newList = [...list];
        newList[idx][name] = e.target.value;
        setList(newList);
    }

    const handleClickUpdate = () => {
        let data = {
            "year": detail['year'],
            "project_code": detail['project_code'],
            "pid": detail['pid'],
            "follow_up_list": list
        }
        // console.log(data)
        followUp(data)
    }

    const followUp = async (body) => {
        setLoading(true)
        let res = await api.followUp(body)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                //alert(res['data']['message'])
                onSubmit()
                onClose()
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>อัพเดทข้อมูล</Box>
                        </Box>
                        <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                            <IconButton onClick={() => { onClose() }}>
                                <ClearIcon />
                            </IconButton>
                        </Box>
                    </Box>

                    <Box sx={{ display: 'grid', gridGap: '15px', margin: '10px 0' }}>
                        {list.map((item, index) => (
                            <Box key={index}>
                                <Box sx={{ fontWeight: 600 }}>{item['field_name']} {' '}
                                    {item['field'] === 'height' ? '(CM)'
                                        : item['field'] === 'weight' ? '(KG)'
                                            : ''
                                    }
                                </Box>
                                <NoArrowTextField
                                    fullWidth
                                    size='small'
                                    value={item['value']}
                                    onChange={(e) => { handleChange(e, index, 'value') }}
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                        ))}
                        <Box sx={{ textAlign: 'center' }}>
                            <Button
                                variant='contained'
                                onClick={() => { handleClickUpdate() }}
                            >อัพเดทข้อมูล</Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    )
}

export default ModalUpdateData
